import axios from "axios";
import CryptoJS from 'crypto-js';
const { VUE_APP_SHIELD_URL, VUE_APP_SPONSOR, VUE_APP_CRYPTO } = process.env;

function decryptFromURL(encryptedData) {
  const key = atob(VUE_APP_CRYPTO);
  const base64 = encryptedData.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((encryptedData.length + 3) % 4);
  const bytes = CryptoJS.AES.decrypt(base64, key);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedData;
}

export default class ShieldService {

  static async newCreateStep(userData, benefData, planData, servicesData, step , tokenStep) {
    try {

      let url;
      const jsonData = { userData, benefData, planData, servicesData, step, sponsor: VUE_APP_SPONSOR };

      if (servicesData.type == 'create') {
        url = '/step/newCreate';
      } else if (servicesData.type == 'update') {
        url = '/step/newUpdate';
      }
      const carroResponse = await axios.post(
        `${VUE_APP_SHIELD_URL}${url}`,
        jsonData,
        {
          headers: {
            // Se agrega el header de autorización
            "x-captcha-authorization": tokenStep,
          },
        }
      );
      
      return carroResponse;

    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error en el servicio Stepers",
      };
    }
  }

  static async newGetStepAbandoned(stepId) {

    const shieldRes = await axios.get(
      `${VUE_APP_SHIELD_URL}/step/newGetAbandoned/${stepId}`
    );
    if (shieldRes.data.status === "ok") return shieldRes.data.data;
    else throw shieldRes.data;
  }

  static async createContactActiveCampain(userData, servicesData) {

    try {
      const shieldRes = await axios.post(`${VUE_APP_SHIELD_URL}/activeCampain/createContact`,
        {
          userData,
          servicesData,
          sponsor: VUE_APP_SPONSOR,
        }
      );

      return shieldRes.data;

    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error al crear el contacto",
      };
    }
  }

  static async updateContactActiveCampain(userData, planData, servicesData, index) {

    try {

      const shieldRes = await axios.put(`${VUE_APP_SHIELD_URL}/activeCampain/updateContact`,
        {
          userData,
          planData,
          servicesData,
          index,
          sponsor: VUE_APP_SPONSOR,
        }
      );

      return shieldRes.data;

    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error al actualizar el contacto",
      };
    }
  }

  static async getContactActiveCampain(email) {

    try {

      const shieldRes = await axios.get(`${VUE_APP_SHIELD_URL}/activeCampain/getContact/${email}`);

      return shieldRes.data;

    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error al actualizar el contacto",
      };
    }
  }

  //Lógica para redireccionar los planes cuando tiene un código de descuento
  static async getPlans(age, code) {

    // console.log(age);
    // console.log(code);

    //Obtener los parámetros para buscar planes
    var cantBenf;
    var category;
    var maxAge = age;

    if ( maxAge >= 18 && maxAge <= 54) {
      category = "IRAM01"; //Ver Tarifario
      cantBenf = "Plan18-54";
    } else if ( maxAge >= 55 && maxAge <= 64) {
      category = "IRAM02";
      cantBenf = "Plan55-64";
    } else if ( maxAge >= 65 && maxAge <=79) {
      category = "IRAM03";
      cantBenf = "Plan65-79";
    } else if ( maxAge > 80) {
      category = "IRAM04";
      cantBenf = "Plan80+";
    }

    try {

      // console.log(category);
      var url = `${VUE_APP_SHIELD_URL}/oncologico`
      var params = "";

      // if (!code) {
      //   params = url + `?sponsor=${VUE_APP_SPONSOR}&category=${category}&cantBenf=${cantBenf}&age=${maxAge}&code=${code}&t=${Date.now()}`
      // } else {
      //   params = url + `?sponsor=${VUE_APP_SPONSOR}&category=${category}&cantBenf=${cantBenf}&age=${maxAge}&t=${Date.now()}`
      // }

      if (code) {
        params = url + `?sponsor=${VUE_APP_SPONSOR}&category=${category}&cantBenf=${cantBenf}&age=${maxAge}&code=${code}&t=${Date.now()}`
      } else {
        params = url + `?sponsor=${VUE_APP_SPONSOR}&category=${category}&cantBenf=${cantBenf}&age=${maxAge}&t=${Date.now()}`
      }
      //Llamada al controlador oncologico en SHIELD, para la busqueda de planes
      const shieldRes = await axios.get(
        params
      );

    const decrypted = decryptFromURL(shieldRes.data.data);
    let planssss = JSON.parse(decrypted); // si originalmente era un array/objeto

      return shieldRes.data.status === "ok" ? planssss : [];
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrio un error al obtener los planes",
      };
    }
  }

  static async getPeople(personID) {

    try {

      const shieldRes = await axios.get(
        `${VUE_APP_SHIELD_URL}/person/get/${personID}`,
      );

      return shieldRes.data.status === "ok" ? shieldRes.data.data : [];
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrio un error al obtener los planes",
      };
    }
  }

  static async createInsurance(person, beneficiaries, plan, stepId) {

    person.forecast = person.salud
    person.birthdate = person.dates

    //Generar Array ordenado de Beneficiarios
    var BenefData = [];

    if (person.typePlan == 'Familiar') {
      beneficiaries.forEach((benef) => {
        BenefData.push({
          name: benef.name,
          surname: benef.surname,
          rut: benef.rut,
          parentesco: benef.tipo,
          fechaNacimiento: '' + benef.day.id + '-' + benef.month.number + '-' + benef.year.id,
        });
      });
    }

    person.BenefData = BenefData;

    //Se genera la petición a SIELD para generar la Insurance y conección a Instanda
    const jsonData = { person, planId: plan._id, stepId: stepId };

    const shieldRes = await axios.post(
      // `${VUE_APP_SHIELD_URL}/oncologico`,
      //aca hay que cambiar algo al parecer o al menos bipassear el proceso de insurance
      `${VUE_APP_SHIELD_URL}/oncologico/createWithRunWayPayment`,
      jsonData
    );
    if (shieldRes.data.status === "ok") return shieldRes.data.data.link;
    else throw shieldRes.data;
  }


  static async createInsuranceWithToku(person, beneficiaries, plan, stepId) {

    person.forecast = person.salud
    person.birthdate = person.dates

    //Generar Array ordenado de Beneficiarios
    var BenefData = [];
    if (beneficiaries) {
      beneficiaries.forEach((benef) => {
        BenefData.push({
          name: benef.name,
          surname: benef.surname,
          rut: benef.rut,
          parentesco: benef.tipo,
          fechaNacimiento: '' + benef.day + '-' + benef.month + '-' + benef.year,
        });
      });
      person.BenefData = BenefData;
    }

    var sponsorTokuRedirect = process.env.VUE_APP_SPONSOR_TOKU_REDIRECT

    //Se genera la petición a SIELD para generar la Insurance y conección a Instanda
    const jsonData = { person, planId: plan[0]._id, stepId: stepId, sponsorTokuRedirect: sponsorTokuRedirect };

    const shieldRes = await axios.post(
      `${VUE_APP_SHIELD_URL}/oncologico/createWithToku`,
      jsonData
    );
    if (shieldRes.data.status === "ok") return shieldRes.data.data;
    else throw shieldRes.data;
  }

  static async getMigrates(cotizacionId) {
    const cotizacionData = await axios.get(`${VUE_APP_SHIELD_URL}/oncologico/getMigrates/${cotizacionId}`);
    if (cotizacionData.data.status === "ok") return cotizacionData.data.data;
    else throw cotizacionData.data;
  }

  static async updateMigrates(cotizacionId, plan) {

    //Se genera la petición a SIELD para generar la Insurance y conección a Instanda
    const jsonData = {
      cotizacionId: cotizacionId,
      planId: plan[0]._id
    };

    const shieldRes = await axios.put(
      // `${VUE_APP_SHIELD_URL}/oncologico`,
      `${VUE_APP_SHIELD_URL}/oncologico/updateMigrates/${cotizacionId}`,
      jsonData
    );
    if (shieldRes.data.status === "ok") return shieldRes.data.data.link;
    else throw shieldRes.data;
  }

  static async getUFPrice() {

    try {

      const shieldRes = await axios.get(
        `${VUE_APP_SHIELD_URL}/hogar/getUf`,
      );

      return shieldRes.data.status === "ok" ? shieldRes.data.data : [];
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrio un error al obtener el valor de la UF",
      };
    }
  }

}



